// Bilingual FR/EN translations for Grizzly
export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      histoire: "L'Histoire",
      story: "La Tradition",
      menu: "La Carte",
      gallery: "Galerie",
      reservation: "Réservation",
      contact: "Contact",
      reserve: "Réserver",
    },
    hero: {
      location: "Le Grand-Saconnex · Genève",
      title: "La Potence",
      subtitle: "L'art de la viande flambée, suspendue à la fonte forgée.",
      description:
        "Un rituel ancestral où la flamme rencontre l'acier, où la viande se consume lentement au-dessus de cinq sauces signatures. Une mise en scène à votre table.",
      ctaReserve: "Réserver une table",
      ctaMenu: "Découvrir la carte",
      scroll: "Faire défiler",
    },
    story: {
      overline: "La Tradition",
      title: "Un Spectacle Culinaire",
      paragraph1: "La Potence flambée au whisky.",
      paragraph2: "Servie avec riz et cinq sauces.",
      paragraph3: "",
      pillar1Title: "Le Feu",
      pillar1Desc: "Flambage tableside au whisky.",
      pillar2Title: "Le Fer",
      pillar2Desc: "Potence forgée à la main.",
      pillar3Title: "Les Sauces",
      pillar3Desc: "Cinq créations maison.",
    },
    menu: {
      overline: "La Carte",
      title: "Notre Carte",
      subtitle:
        "Une carte courte, des produits suisses, une obsession : la viande.",
      tabAll: "Tout",
      tabStarters: "Entrées",
      tabPotence: "La Potence",
      tabMeats: "Nos Viandes",
      tabFish: "Poissons",
      tabDesserts: "Desserts",
      viewFullMenu: "Carte complète",
      currency: "CHF",
    },
    gallery: {
      overline: "Le Lieu",
      title: "L'Atmosphère",
      subtitle:
        "Entre boiseries chaudes, lumière tamisée et le crépitement du feu.",
    },
    reservation: {
      overline: "Réserver",
      title: "Votre Table Vous Attend",
      subtitle:
        "Réservez votre soirée Potence. Confirmation par téléphone sous 24h.",
      name: "Nom complet",
      email: "Email",
      phone: "Téléphone",
      date: "Date",
      time: "Heure",
      guests: "Convives",
      notes: "Demande particulière (optionnel)",
      submit: "Confirmer la réservation",
      submitting: "Envoi en cours...",
      success: "Réservation envoyée ! Nous vous confirmerons par téléphone.",
      error: "Une erreur est survenue. Merci de réessayer ou de nous appeler.",
      person: "personne",
      persons: "personnes",
      closedTitle: "Réservation par téléphone",
      closedText:
        "Les réservations en ligne sont momentanément fermées. Contactez-nous directement pour réserver votre table.",
      callUs: "Nous appeler",
    },
    contact: {
      overline: "Nous Trouver",
      title: "Venez Nous Rencontrer",
      address: "Chem. Edouard-Sarasin 26",
      city: "1218 Le Grand-Saconnex, Suisse",
      phoneLabel: "Téléphone",
      phone: "022 798 10 11",
      hoursLabel: "Horaires",
      hoursWeek: "Mardi – Samedi · 12h – 14h30 / 19h – 23h",
      hoursClosed: "Fermé dimanche et lundi",
      directions: "Itinéraire",
    },
    footer: {
      tagline: "La Potence depuis 1987.",
      rights: "Tous droits réservés.",
      crafted: "Restaurant Grizzly · Le Grand-Saconnex",
    },
  },
  en: {
    nav: {
      home: "Home",
      histoire: "Our Story",
      story: "The Tradition",
      menu: "Menu",
      gallery: "Gallery",
      reservation: "Booking",
      contact: "Contact",
      reserve: "Book a Table",
    },
    hero: {
      location: "Le Grand-Saconnex · Geneva",
      title: "La Potence",
      subtitle: "The art of flame-grilled meat, hung from hand-forged iron.",
      description:
        "An ancestral ritual where flame meets steel and meat slowly chars above five signature sauces. Performed at your table.",
      ctaReserve: "Book a Table",
      ctaMenu: "View the Menu",
      scroll: "Scroll",
    },
    story: {
      overline: "The Tradition",
      title: "A Culinary Spectacle",
      paragraph1: "The Potence, flambéed with whisky.",
      paragraph2: "Served with rice and five sauces.",
      paragraph3: "",
      pillar1Title: "The Fire",
      pillar1Desc: "Tableside whisky flambé.",
      pillar2Title: "The Iron",
      pillar2Desc: "Hand-forged gallows.",
      pillar3Title: "The Sauces",
      pillar3Desc: "Five house creations.",
    },
    menu: {
      overline: "The Menu",
      title: "Our Menu",
      subtitle: "A short menu, Swiss produce, one obsession: meat.",
      tabAll: "All",
      tabStarters: "Starters",
      tabPotence: "La Potence",
      tabMeats: "Meats",
      tabFish: "Fish",
      tabDesserts: "Desserts",
      viewFullMenu: "Full menu",
      currency: "CHF",
    },
    gallery: {
      overline: "The Place",
      title: "The Atmosphere",
      subtitle: "Warm wood, soft light, the crackle of fire.",
    },
    reservation: {
      overline: "Book",
      title: "Your Table Awaits",
      subtitle:
        "Book your Potence evening. Confirmation by phone within 24h.",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      date: "Date",
      time: "Time",
      guests: "Guests",
      notes: "Special request (optional)",
      submit: "Confirm booking",
      submitting: "Sending...",
      success: "Booking sent! We'll confirm by phone shortly.",
      error: "Something went wrong. Please try again or call us.",
      person: "guest",
      persons: "guests",
      closedTitle: "Bookings by phone",
      closedText:
        "Online bookings are momentarily closed. Please contact us directly to reserve your table.",
      callUs: "Call us",
    },
    contact: {
      overline: "Find Us",
      title: "Come Meet Us",
      address: "Chem. Edouard-Sarasin 26",
      city: "1218 Le Grand-Saconnex, Switzerland",
      phoneLabel: "Phone",
      phone: "022 798 10 11",
      hoursLabel: "Hours",
      hoursWeek: "Tue – Sat · 12pm – 2:30pm / 7pm – 11pm",
      hoursClosed: "Closed Sunday & Monday",
      directions: "Directions",
    },
    footer: {
      tagline: "La Potence since 1987.",
      rights: "All rights reserved.",
      crafted: "Restaurant Grizzly · Le Grand-Saconnex",
    },
  },
};

export const menuData = {
  starters: {
    fr: [
      { name: "Salade verte", desc: "", price: 7 },
      { name: "Salade de tomates", desc: "", price: 8 },
      { name: "Salade mêlée", desc: "", price: 10 },
      { name: "Carpaccio de bœuf", desc: "", price: 21 },
      { name: "Cocktail de crevettes", desc: "", price: 18 },
      { name: "6 escargots", desc: "À la bourguignonne", price: 14 },
      { name: "12 escargots", desc: "À la bourguignonne", price: 28 },
      { name: "Foie gras maison", desc: "", price: 28 },
      { name: "Jambon cru", desc: "", price: 25 },
      { name: "Viande séchée", desc: "Spécialité des Grisons", price: 29 },
    ],
    en: [
      { name: "Green salad", desc: "", price: 7 },
      { name: "Tomato salad", desc: "", price: 8 },
      { name: "Mixed salad", desc: "", price: 10 },
      { name: "Beef carpaccio", desc: "", price: 21 },
      { name: "Shrimp cocktail", desc: "", price: 18 },
      { name: "6 snails", desc: "Burgundy-style", price: 14 },
      { name: "12 snails", desc: "Burgundy-style", price: 28 },
      { name: "Homemade foie gras", desc: "", price: 28 },
      { name: "Cured ham", desc: "", price: 25 },
      { name: "Dried meat", desc: "Grisons specialty", price: 29 },
    ],
  },
  potence: {
    fr: [
      {
        name: "La Potence flambée au whisky",
        desc: "Servie avec riz et cinq sauces · 220g par personne",
        price: 46,
        suffix: "/ pers.",
        signature: true,
      },
      {
        name: "Menu Potence du Chef",
        desc: "Entrée · La Potence flambée · Dessert du chef",
        price: 61,
        suffix: "/ pers.",
        signature: true,
      },
    ],
    en: [
      {
        name: "Potence flambéed with whisky",
        desc: "Served with rice and five sauces · 220g per person",
        price: 46,
        suffix: "/ pers.",
        signature: true,
      },
      {
        name: "Chef's Potence Menu",
        desc: "Starter · Flambéed Potence · Chef's dessert",
        price: 61,
        suffix: "/ pers.",
        signature: true,
      },
    ],
  },
  meats: {
    fr: [
      { name: "Entrecôte nature 220g", desc: "Pommes frites & salade", price: 39 },
      { name: "Entrecôte marchand de vin 220g", desc: "Sauce au vin rouge", price: 42 },
      { name: "Entrecôte Café de Paris 220g", desc: "Beurre maître d'hôtel signature", price: 42 },
      { name: "Entrecôte au poivre vert 220g", desc: "Sauce au poivre vert et cognac", price: 42 },
      { name: "Filet de bœuf nature 220g", desc: "Cuisson à votre goût", price: 42 },
      { name: "Filet de bœuf marchand de vin 220g", desc: "Sauce au vin rouge", price: 46 },
      { name: "Filet de bœuf Café de Paris 220g", desc: "Beurre maître d'hôtel signature", price: 46 },
      { name: "Filet de bœuf au poivre vert 220g", desc: "Sauce au poivre vert et cognac", price: 46 },
      { name: "Portion de pommes frites", desc: "En supplément", price: 6 },
    ],
    en: [
      { name: "Ribeye steak 220g", desc: "French fries & salad", price: 39 },
      { name: "Ribeye marchand de vin 220g", desc: "Red wine sauce", price: 42 },
      { name: "Ribeye Café de Paris 220g", desc: "Signature maître d'hôtel butter", price: 42 },
      { name: "Ribeye green pepper 220g", desc: "Green peppercorn & cognac sauce", price: 42 },
      { name: "Beef fillet 220g", desc: "Cooked to your liking", price: 42 },
      { name: "Beef fillet marchand de vin 220g", desc: "Red wine sauce", price: 46 },
      { name: "Beef fillet Café de Paris 220g", desc: "Signature maître d'hôtel butter", price: 46 },
      { name: "Beef fillet green pepper 220g", desc: "Green peppercorn & cognac sauce", price: 46 },
      { name: "Side of french fries", desc: "Extra portion", price: 6 },
    ],
  },
  fish: {
    fr: [
      { name: "Gambas à la provençale", desc: "Tomates, ail, herbes de Provence", price: 39 },
      { name: "Gambas au curry", desc: "Sauce curry crémeuse", price: 39 },
      { name: "Filets de perche", desc: "Selon arrivage, beurre meunière", price: 39 },
    ],
    en: [
      { name: "Provençal-style prawns", desc: "Tomato, garlic, Provence herbs", price: 39 },
      { name: "Curried prawns", desc: "Creamy curry sauce", price: 39 },
      { name: "Perch fillets", desc: "Subject to availability, meunière butter", price: 39 },
    ],
  },
  desserts: {
    fr: [
      { name: "Crème brûlée", desc: "", price: 10 },
      { name: "Panna cotta aux fruits des bois", desc: "", price: 10 },
      { name: "Mousse au chocolat", desc: "Maison", price: 10 },
      { name: "Cassata arrosée maraschino", desc: "", price: 11 },
      { name: "Parfait Mocca", desc: "Flambé au cognac et à l'orange", price: 12 },
      { name: "Coupe Danemark", desc: "Glace vanille, sauce chocolat, chantilly", price: 12 },
      { name: "Café glacé", desc: "Glace café, espresso, chantilly", price: 12 },
      { name: "Boule de glace", desc: "Vanille · chocolat · mocca · citron · abricot · poire", price: 5 },
      { name: "Sorbet Colonel", desc: "Sorbet citron à la vodka", price: 15 },
      { name: "Coupe Valaisanne", desc: "Sorbet abricot et eau-de-vie d'abricot", price: 15 },
      { name: "Coupe Williams", desc: "Sorbet poire et eau-de-vie Williamine", price: 15 },
      { name: "Coupe Limoncello", desc: "Sorbet citron et limoncello", price: 15 },
      { name: "Coupe Général", desc: "Glace vanille et whisky", price: 15 },
      { name: "Coupe Président", desc: "Glace vanille et Cointreau", price: 15 },
    ],
    en: [
      { name: "Crème brûlée", desc: "", price: 10 },
      { name: "Panna cotta with forest berries", desc: "", price: 10 },
      { name: "Chocolate mousse", desc: "House-made", price: 10 },
      { name: "Cassata with maraschino", desc: "", price: 11 },
      { name: "Mocha Parfait", desc: "Flambéed with cognac and orange", price: 12 },
      { name: "Danemark Sundae", desc: "Vanilla ice cream, chocolate sauce, whipped cream", price: 12 },
      { name: "Iced coffee", desc: "Coffee ice cream, espresso, whipped cream", price: 12 },
      { name: "Single scoop", desc: "Vanilla · chocolate · mocha · lemon · apricot · pear", price: 5 },
      { name: "Colonel sorbet", desc: "Lemon sorbet with vodka", price: 15 },
      { name: "Valaisanne sundae", desc: "Apricot sorbet with apricot brandy", price: 15 },
      { name: "Williams sundae", desc: "Pear sorbet with Williamine pear brandy", price: 15 },
      { name: "Limoncello sundae", desc: "Lemon sorbet with limoncello", price: 15 },
      { name: "Général sundae", desc: "Vanilla ice cream with whisky", price: 15 },
      { name: "Président sundae", desc: "Vanilla ice cream with Cointreau", price: 15 },
    ],
  },
};

// HD gallery photos provided by the restaurant
export const galleryImages = [
  "https://customer-assets.emergentagent.com/job_potence-modern/artifacts/m53ayfdt_3.jpg", // couple + Potence + fries
  "https://customer-assets.emergentagent.com/job_b50663e4-fde8-455b-a204-ec909b7b7d32/artifacts/ao5m04j9_potence%201.JPG", // potence isolated
  "https://customer-assets.emergentagent.com/job_potence-modern/artifacts/ck98f7na_DSC_0003.JPG", // dining area
  "https://customer-assets.emergentagent.com/job_potence-modern/artifacts/sprbmyt7_DSC_0008.JPG", // dining area 2
  "https://customer-assets.emergentagent.com/job_potence-modern/artifacts/luw9rut4_DSC_0016.JPG", // corner table Geneva
  "https://customer-assets.emergentagent.com/job_potence-modern/artifacts/ewh8g9r2_DSC_0021.JPG", // round table set
  "https://customer-assets.emergentagent.com/job_b50663e4-fde8-455b-a204-ec909b7b7d32/artifacts/sz8v6337_potence%202.JPG", // potence detail with sauces
];

export const POTENCE_HERO = "https://customer-assets.emergentagent.com/job_b50663e4-fde8-455b-a204-ec909b7b7d32/artifacts/ao5m04j9_potence%201.JPG";
export const POTENCE_STORY = "https://customer-assets.emergentagent.com/job_b50663e4-fde8-455b-a204-ec909b7b7d32/artifacts/sz8v6337_potence%202.JPG";
export const HISTOIRE_IMAGE = "https://customer-assets-v7afamib.emergentagent.net/job_potence-modern/artifacts/eb7my6n4_histoire.png";

export const histoireContent = {
  fr: {
    overline: "Depuis 1970",
    title: "Un peu d'histoire",
    intro: "Plus de 50 ans de passion familiale au Grand-Saconnex.",
    timeline: [
      {
        year: "1970",
        title: "La naissance",
        text:
          "Le restaurant Le Grizzly voit le jour, grâce à la passion et au savoir-faire des époux Herbert et Madeleine Suter. Avec leur dévouement, ils ont fait de cet établissement une véritable institution au Grand-Saconnex, reconnue dans tout le canton de Genève.",
      },
      {
        year: "1982",
        title: "L'arrivée de la Potence",
        text:
          "Une spécialité aujourd'hui incontournable fait son apparition : la Potence, servie dans un cadre chaleureux au décor unique qui contribue à l'identité du lieu.",
      },
      {
        year: "2001",
        title: "La relève familiale",
        text:
          "À la suite du décès d'Herbert Suter, ses enfants Jacqueline et Patrick reprennent fièrement les rênes de l'établissement, poursuivant ainsi l'œuvre de leurs parents avec cœur et fidélité.",
      },
      {
        year: "Aujourd'hui",
        title: "Une belle tradition qui continue",
        text:
          "M. José Rodrigues, figure bien connue de la région, reprend le flambeau à son tour. Animé par la même passion de l'accueil et du partage, il vous reçoit avec honneur et enthousiasme pour vous faire vivre un moment convivial et gourmand.",
      },
    ],
    welcome: "Bienvenue au Grizzly,",
    bonAppetit: "et bon appétit !",
  },
  en: {
    overline: "Since 1970",
    title: "A little history",
    intro: "Over 50 years of family passion in Le Grand-Saconnex.",
    timeline: [
      {
        year: "1970",
        title: "The beginning",
        text:
          "Le Grizzly was born thanks to the passion and craftsmanship of Herbert and Madeleine Suter. Through their dedication, they built a true institution in Le Grand-Saconnex, renowned throughout the Canton of Geneva.",
      },
      {
        year: "1982",
        title: "The Potence arrives",
        text:
          "A specialty that is now iconic makes its appearance: La Potence, served in a warm setting with a unique décor that defines the identity of the place.",
      },
      {
        year: "2001",
        title: "A family torch passed on",
        text:
          "Following Herbert Suter's passing, his children Jacqueline and Patrick proudly took the reins, carrying on their parents' work with heart and loyalty.",
      },
      {
        year: "Today",
        title: "A beautiful tradition continues",
        text:
          "M. José Rodrigues, a well-known figure in the region, now carries the torch. Driven by the same passion for hospitality and sharing, he welcomes you with honour and enthusiasm to live a warm, gourmet moment.",
      },
    ],
    welcome: "Welcome to Grizzly,",
    bonAppetit: "and bon appétit!",
  },
};
